import App from "app";
import WAHighChartsMixin from "app/components/dashboard/visualization/charts/scatterplot/mixins/scatterplot-highcharts";
import "app/components/dashboard/visualization/charts/chart";

App.module("Chart.ScatterPlot", function (ScatterPlot, App, Backbone, Marionette, $, _) {
    ScatterPlot.View = App.Chart.Default.ChartView.extend({
        initialize: function () {
            _(this).extend(WAHighChartsMixin);
            App.Chart.Default.ChartView.prototype.initialize.apply(this, arguments);
        },
    });
});
